import { ALGOS_E } from "@constants/Algos";
import { getMaxSpeedTitle } from "@utils/hash.utils";
import { getLangFromLocal } from "@utils/lang";
import { utcTimeFormat } from "@utils/moscowTime";
import { Tick, TooltipItem } from "chart.js";
import { LocaleLangE } from "../../i18n/LocaleContext";
import ChartColors from "./ChartColors";
import { IChartOptionMethods } from "./ChartUtils";

export type ChartLabelsAndData = {
  labels: number[];
  data: number[];
  accepted: number[];
  rejected: number[];
  status: number[];
};

export function getRejectRate(reject: number, accept: number): number {
  const total = reject + accept;
  if (total > 0) {
    return (reject / total) * 100;
  }
  return 0;
}

// interface HasChartProps {
//   //onLastValueChanged: OnChartLastValueChanged,
//   onLastTickChanged: () => void;
//   speedDrops?: number;
//   defaultSpeed?: number;
// }

export interface TooltipLabel {
  title: string;
  value: string;
  unit: string;
}
export function createChartOptionMethods(
  onLastTickChanged: () => void,
  asioxYName: string,
  speedDrops?: number,
  defaultSpeed?: number,
): IChartOptionMethods {

  return {

    lastTickValue: null,

    getBackgroundColor(value: number): ChartColors {
      if (defaultSpeed === undefined || speedDrops === undefined) {
        return ChartColors.BG_PRIMARY;
      }
      const defaultSpeedReal = defaultSpeed! * 0.95;
      if (value > defaultSpeedReal) return ChartColors.OK;
      if (speedDrops) {
        if (value <= defaultSpeedReal && value > speedDrops)
          return ChartColors.LOW;
      } else {
        if (value > 0 && value <= defaultSpeedReal) return ChartColors.LOW;
      }
      return ChartColors.OFF;
    },

    getTooltipTitle(label: number): string {
      const isRus = (getLangFromLocal() as LocaleLangE) === LocaleLangE.RU;
      const strT = isRus ? "Время: " : "Time: ";
      return (
        strT +
        utcTimeFormat(label,
          label % (60 * 1000) === 0 ? "DD/MM/YY HH:mm" : "DD/MM/YY HH:mm:ss"
        )
      );
    },

    getTooltipLabel(
      item: TooltipItem<"line">,
      algos: ALGOS_E
    ): string {
      if (item.datasetIndex === 0) { // hashrate
        const speedTitle = getMaxSpeedTitle([item.parsed.y ?? 0], algos);
        return `${item.dataset.label}: ${speedTitle[0].toFixed(2)} ${speedTitle[1]}`;
      }
      if (item.datasetIndex === 1) { // reject rate
        return `${item.dataset.label}: ${item.parsed.y?.toFixed(2)}%`;
      }
      return "";
    },

    onLastTick(last: Tick | null) {
      if (last === null) return;
      if (this.lastTickValue === null) {
        this.lastTickValue = last.value;
        return;
      }
      if (this.lastTickValue !== last.value) {
        this.lastTickValue = last.value;
        onLastTickChanged();
      }
    },

    getXTick(x: any, periodDays: number): string {
      return utcTimeFormat(x,
        periodDays > 15 ? "DD.MM.YY" :
          periodDays > 13 ? "DD.MM HH:mm" :
            periodDays > 2 ? "DD MMM HH:mm" : "HH:mm"
      );
    },

    getYTick(value: number): string {
      return getMaxSpeedTitle([value])[0].toFixed(2);
    },

    // getTooltipYAlign(item?: TooltipItem<"line">): "top" | "center" | "bottom" {
    //   if (!item) return "bottom";
    //   const maxV = Math.max(...(item.dataset.data as number[]));
    //   const raw = item.raw as number;
    //   if (raw >= maxV - maxV / 10 && raw <= maxV) return "top";
    //   return "bottom";
    // }
  }
}
